import React from 'react';
import {connect} from 'react-redux';
import Text from '../containers/Text';

const RouteLink = ({search, end, text='route-link', className, isDetailLinkOnList, isDetailLinkOnMap}) => {
  const routeURL = `//maps.google.com/maps?saddr=${search.address}&daddr=${end.street}${end.houseNumber || ''},${end.zip} ${end.city}`;

  return <a href={routeURL} target='_blank' className={['btn btn-link btn-sm route-link', className].join(' ')}
            onClick={() => {
                if (isDetailLinkOnList) {
                    window.wts.push(['send', 'click', {linkId: 'Liste.Route'}]); //bei Klick auf Route
                }
                if (isDetailLinkOnMap) {
                    window.wts.push(['send', 'click', {linkId: 'Karte.Route'}]); //bei Klick auf Route-Link 
    
                }
                else {
                    window.wts.push(['send', 'click', {linkId: 'Route'}]);
                }
                return true;
            }}
        >

    <span className="halflings halflings-road"></span>
    {' '} <Text id={text} />
  </a>
}

const mapStateToProps = ({search}) => ({
  search
});

export default connect(mapStateToProps)(RouteLink);
